export default __webpack_public_path__ + "static/media/mobility_arrow_2.725e0d92.svg";